import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { FilterList, FilterListItem, FilterLiveSearch } from "react-admin";
import { FilterSidebar, FilterSidebarTemplateCategory } from "$components/FilterSidebar";
import { nonValueBitCategoryTypeChoices } from "$constants/categoryTypeChoices";
export const CategoriesSidebar = ({ isTemplate }) => {
    return (_jsxs(FilterSidebar, { children: [_jsx(FilterLiveSearch, { name: "name", source: "name", label: "Name" }), isTemplate && _jsx(FilterSidebarTemplateCategory, {}), _jsx(FilterList, { label: "Category type", icon: "", children: nonValueBitCategoryTypeChoices.map((choice) => (_jsx(FilterListItem, { label: choice.name, value: { type: choice.id } }))) })] }));
};
